import { AbstractRetailApi } from './AbstractRetailApi'

class RetailApiV2 extends AbstractRetailApi {
  version: number = 2
}

export default new RetailApiV2()
